

export default {
  data() {
    return {
      allObjects: null,
      fUrl: null,
      search: null
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    hasObject() {
      return this.allObjects !== null && this.allObjects.length > 0
    }
  },
  methods: {
    didFetch() {},
    fetchData() {
      if (this.allObjects === null && this.fUrl !== null) {
        this.$fetch(this.fUrl)
        .then(data => {
          this.allObjects = data
          if (this.didFetch !== null) {
            this.didFetch(data)
          }
        }).catch(() => console.log('reset password error'))
      }
    },
    tableFilter(items, search) {
      if (search.column !== null && search.search !== null && search.search !== undefined && search.search.length > 0) {
        search.column.search = search.search
      }
      var filtered = items
      this.headers.forEach(function(column) {
        if (column.search !== null && column.search !== undefined && column.search.length > 0) {
          var arg = column.argument !== undefined ? column.argument : null
          var keys = column.value ? column.value.split('.') : []
          filtered = filtered.filter((item) => {
            keys.forEach((key) => {
              item = item[key]
            })
            if (column.filter !== null) {
              item = column.filter(item, arg)
            }
            return column.search.includes(item)
          })
        }
      })
      return filtered
    },
    filterColor(key) {
      return key.search !== undefined && key.search !== null && key.search.length ? 'primary--text' : 'grey--text'
    }
  }
}
